import { render, staticRenderFns } from "./OutlineShadow.vue?vue&type=template&id=0fa85d92"
import script from "./OutlineShadow.vue?vue&type=script&lang=js"
export * from "./OutlineShadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa85d92')) {
      api.createRecord('0fa85d92', component.options)
    } else {
      api.reload('0fa85d92', component.options)
    }
    module.hot.accept("./OutlineShadow.vue?vue&type=template&id=0fa85d92", function () {
      api.rerender('0fa85d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/OutlineShadow.vue"
export default component.exports